import { render, staticRenderFns } from "./SeferTorahPage.vue?vue&type=template&id=01cee1f9&scoped=true&"
import script from "./SeferTorahPage.vue?vue&type=script&lang=js&"
export * from "./SeferTorahPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cee1f9",
  null
  
)

export default component.exports